import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import PropTypes from "prop-types";
import { Field, reduxForm } from "redux-form";
import { FormattedMessage, injectIntl } from "react-intl";
import cx from "classnames";

import CustomDatePicker from "modules/custom-fields/datepicker";
import { validateSexAndAge } from "modules/utils/validations";
import TextField from "modules/forms/fields/text-field";
import CustomRadioField from "modules/forms/fields/custom-radio-field";
import { getLoginMethod } from "modules/auth/auth-selectors";
import constants from "common/constants";

import "react-datepicker/dist/react-datepicker.css";

const { SEX } = constants;
export const FORM_NAME = "sex-age";
export const SEX_FIELD_NAME = "sex";
export const BIRTHDAY_FIELD_NAME = "birthday";

class SexAndAgeInputs extends Component {
  constructor(props) {
    super(props);

    this.state = {
      minDate: moment()
        .subtract(100, "years")
        .toDate(),
      maxDate: moment()
        .subtract(18, "years")
        .toDate()
    };
  }

  static propTypes = {
    onSubmit: PropTypes.func,
    handleSubmit: PropTypes.func,
    isBankIdLogin: PropTypes.bool,
    locale: PropTypes.string.isRequired,
    intl: PropTypes.object.isRequired
  };

  render() {
    const { handleSubmit, onSubmit, locale, intl, isBankIdLogin } = this.props;
    const { minDate, maxDate } = this.state;
    return (
      <form
        className="SexAndAgeForm l-container"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="SexAndAgeForm__Row row-wrapper">
          <div className="SexAndAgeForm__SexContainer">
            <p className="SexAndAgeForm__SexLabel SexAndAgeForm__Label">
              <FormattedMessage id="general-info-form.i_am_a" />
            </p>
            <div className="SexAndAgeForm__SexRadioFields radio-fields">
              <CustomRadioField
                id="sex-man"
                label="general-info-form.man"
                className="SexAndAgeForm__SexRadioField"
                name={SEX_FIELD_NAME}
                value={SEX.MALE}
                disabled={isBankIdLogin}
              />
              <CustomRadioField
                id="sex-woman"
                className="SexAndAgeForm__SexRadioField SexAndAgeForm__SexRadioField--show-validation"
                label="general-info-form.woman"
                name={SEX_FIELD_NAME}
                value={SEX.FEMALE}
                showValidation={true}
                disabled={isBankIdLogin}
              />
            </div>
          </div>
          <div className="SexAndAgeForm__AgeContainer">
            <div className="SexAndAgeForm__AgeContainerInner">
              <p className="SexAndAgeForm__AgeLabel SexAndAgeForm__Label">
                <FormattedMessage id="general-info-form.i_am_born_on" />
              </p>
              <div
                className={cx("SexAndAgeForm__AgeField", {
                  "SexAndAgeForm__AgeField--disabled": isBankIdLogin
                })}
              >
                <Field
                  id="birthday"
                  name={BIRTHDAY_FIELD_NAME}
                  locale={locale}
                  dateFormat="dd MMMM yyyy"
                  showYearDropdown
                  autoComplete="off"
                  dropdownMode="select"
                  minDate={minDate}
                  maxDate={maxDate}
                  placeholderText={intl.formatMessage({
                    id: "general-info-form.i_am_born_on"
                  })}
                  component={CustomDatePicker}
                  disabled={isBankIdLogin}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="SexAndAgeForm__Row SexAndAgeForm__Row--centered">
          <div className="SexAndAgeForm__WeightContainer">
            <div className="SexAndAgeForm__WeightContainerInner">
              <p className="SexAndAgeForm__WeightLabel SexAndAgeForm__Label">
                <FormattedMessage id="general-info-form.weight" />
              </p>
              <TextField
                placeholder={"general-info-form.weight"}
                id="weight"
                type="number"
                name="weight"
                min={1}
              />
            </div>
          </div>
          <div className="SexAndAgeForm__HeightContainer">
            <div className="SexAndAgeForm__HeightContainerInner">
              <p className="SexAndAgeForm__HeightLabel SexAndAgeForm__Label">
                <FormattedMessage id="general-info-form.height" />
              </p>
              <TextField
                placeholder={"general-info-form.height"}
                id="height"
                type="number"
                name="height"
                min={1}
              />
            </div>
          </div>
        </div>
        <button
          className="SexAndAgeForm__Button Button--round"
          type="button"
          onClick={handleSubmit(onSubmit)}
        >
          <FormattedMessage id="app.start" />
        </button>
      </form>
    );
  }
}

export default reduxForm({
  form: FORM_NAME,
  validate: validateSexAndAge,
  destroyOnUnmount: false
})(
  injectIntl(
    connect(state => ({
      locale: state.localeConfig.locale,
      isBankIdLogin: getLoginMethod(state) === constants.LoginMethod.BankId
    }))(SexAndAgeInputs)
  )
);



// WEBPACK FOOTER //
// ./src/modules/general-info/sex-and-age-form.js